import isCpf from '@mobi/utils/validators/cpf'
import isCnpj from '@mobi/utils/validators/cnpj'
import isPhone from '@mobi/utils/validators/phone'
import isEmail from '@mobi/utils/validators/email'
import isName from '@mobi/utils/validators/name'
import isDate from '@mobi/utils/validators/date'

const validators = {
  isRequired: (value) => !value,
  isName: (value) => !isName(value),
  isEmail: (value) => !isEmail(value),
  isCpf: (value) => !isCpf(value),
  isCpfOrCnpj: (value) => !(isCpf(value) || isCnpj(value)),
  isPhone: (value) => !isPhone(value, 11, 11, 'cellphone'),
  isDate: (value) => !isDate(value),
}

const messages = {
  isRequired: () => 'campo obrigatório',
  isName: () => 'digite um nome válido',
  isCpf: () => 'digite um cpf válido',
  isCpfOrCnpj: () => 'digite um documento válido',
  isEmail: () => 'digite um email válido',
  isPhone: () => `digite um celular válido`,
  isDate: () => `digite uma data válida`,
}

export { validators, messages }
